<template>
  <div>
    <h2 class="page-title">已签发 SN</h2>
    <div class="card-panel" style="padding:20px;">
      <div class="table-tools">
        <el-select v-model="vendorId" clearable placeholder="按供应商筛选" @change="loadData">
          <el-option v-for="vendor in vendors" :key="vendor.id" :label="`${vendor.name} / ${vendor.shortCode}`" :value="vendor.id" />
        </el-select>
        <el-button @click="loadData">刷新</el-button>
      </div>
      <el-table :data="rows" width="100%">
        <el-table-column prop="sn" label="SN码" min-width="220" />
        <el-table-column prop="vendorShortCode" label="短编号" width="100" />
        <el-table-column prop="segmentCode" label="SN段1" width="100" />
        <el-table-column prop="customCode" label="SN段2" width="120" />
        <el-table-column prop="verifyCode" label="验证码" width="100" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'disabled' ? 'danger' : 'success'">
              {{ scope.row.status === 'disabled' ? '禁用' : '正常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="产品名" />
        <el-table-column prop="vendorName" label="供应商" />
        <el-table-column prop="launchDate" label="投放日期" />
        <el-table-column prop="launchRegion" label="投放地区" />
        <el-table-column prop="lastVerifiedAt" label="最后验证时间" min-width="180" />
        <el-table-column prop="verifyCount" label="验证次数" width="100" />
      </el-table>
    </div>
  </div>
</template>

<script>
import { getAdminSNs, getVendors } from '../../api/admin'

export default {
  data() {
    return {
      vendorId: '',
      vendors: [],
      rows: [],
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      const { data } = await getVendors()
      this.vendors = data
      this.loadData()
    },
    async loadData() {
      const { data } = await getAdminSNs({ vendorId: this.vendorId || undefined })
      this.rows = data
    },
  },
}
</script>
